import { useSelector } from "react-redux";
import ProductList from "./ProductList";

function Product(){
    const product = useSelector((state) => state.product);    
    return(   
    <div className="productContainer" id="lws-productContainer">
        { product.length > 0 ?  product.map((product)=>(
            <ProductList product={product} key={product.id} />
        )) : <h1>No Product Found</h1>}
    </div>
    );
}
export default Product;